import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { QUOTE_REGENERATE_FORM } from "v4/data/apiRoutes";
import useAutoFetch from "v4/hooks/useAutoFetch";
import useFetch from "v4/hooks/useFetch";
import { generateUrl } from "v4/services/api.service";

export default function useProspectQuotesReoffer(quoteId, closePopup, onReoffered) {
    const { data: form, isLoading: isFormLoading } = useAutoFetch(generateUrl(QUOTE_REGENERATE_FORM, { id: quoteId }));
    const [{ isLoading: isSubmitLoading, isFinished, isError, errorData }, fetchSubmit] = useFetch();
    const formData = form?.['hydra:member'];
    const methods = useForm();

    const withPdfRef = useRef(false);
    const setWithPdf = (value) => { withPdfRef.current = value; };

    const onSubmit = (data) => {
        fetchSubmit({
            url: generateUrl(QUOTE_REGENERATE_FORM, { id: quoteId }),
            config: {
                method: 'POST',
                body: JSON.stringify(data),
            }
        })
    }

    useEffect(() => {
        if (isFinished && !isError) {
            closePopup();
            if (onReoffered) onReoffered({ withPdf: withPdfRef.current });
            withPdfRef.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFinished, isError])

    return {
        formId: 'quoteRegenerateForm',
        isSubmitLoading,
        isFormLoading,
        formData,
        formErrors: errorData,
        onSubmit,
        setWithPdf,
        methods,
    }
}
